/**
 * 门店营收监控：统一清理某门店的所有前端缓存（内存 + 可选 localStorage）
 * 用于「刷新」时强制下次请求拉取最新数据，避免展示过期缓存。
 *
 * 各模块 TTL 汇总：
 * - store-data-from-cache：每次进入页面请求后端，无前端内存缓存
 * - 渠道房型价格：内存 2 分钟，localStorage 同 TTL 校验
 * - 房态：房型列表永久、房型数据 1 分钟、平均价按当天
 * - 房态近日：按门店内存缓存
 * - 远期房态：按门店内存缓存
 * - RevPAR：内存 1 天（月度/日度）
 * - 业务报告日度/月度：内存 1 天
 */
import { clearChannelPriceCache } from '../components/ChannelPrice/utils/channelPriceCache';
import { clearRoomStatusCache } from '../components/RoomStatus/utils/roomStatusCache';
import { clearRoomStatusRecentlyCache } from './roomStatusRecentlyCache';
import { clearFutureRoomStatusCache } from './futureRoomStatusCache';
import { clearRevparCache } from '../components/RevPAR/utils/revparCache';
import { clearBusinessReportDailyCache } from './businessReportDailyCache';
/**
 * 清除指定门店的所有内存缓存，不删 localStorage。
 * 刷新后各 hook 会重新请求，新结果会再次写入 localStorage。
 * 若需连 localStorage 一起清空（如排查缓存问题），可再调用 clearStoreFromLocalStorage(storeId)。
 */
export function clearAllStoreRevenueCachesForStore(storeId) {
    clearChannelPriceCache(storeId);
    clearRoomStatusCache(storeId);
    clearRoomStatusRecentlyCache(storeId);
    clearFutureRoomStatusCache(storeId);
    clearRevparCache(storeId);
    clearBusinessReportDailyCache(storeId);
}
export { clearStoreFromLocalStorage } from './storeRevenueLocalStorage';
